import React, { Component } from 'react'
import { Modal, ModalHeader, ModalBody, ModalFooter, Button, Alert, Label, Input, } from 'reactstrap'
import getRecordType from '../../helpers/users/getRecordType'
import { Form, } from 'reactstrap'
import { UserFormGroup, } from './'
import { db } from '../../config/firebaseconfig'
import keys from 'mout/object/keys'
import timestamper from '../../helpers/timestamper'
import queryString from 'query-string'
import getRequest from '../../helpers/getRequest';
import getLastLogin from '../../helpers/users/getLastLogin';

const uuid = require('uuid/v1')

/*
    <ManageRecordModal
      isOpen={this.props.modal === 'record'}
      key='ManageRecordModal'
      toggle={this.props.closeModal}
      recordId={this.props.recordId}
      educators={this.props.educators}
      schools={this.props.schools}
      students={this.props.students}
      districts={this.props.districts}
      classes={this.props.classes}
      deleteRecord={this.props.deleteRecord}
      isDeleting={this.props.isDeleting}
      isDeletingError={this.props.isDeletingError}
    />
*/

/*
  refactor! Too BIG. Redux plus separate container and view
*/

class ManageRecordModal extends Component {
  constructor(props) {
    super(props)

    this.state = {
      recordType: '',
      record: null,
      error: '',
      editMode: false,
      isSaving: false,
      savingComplete: false,
      sendingInvite: false,
      sendingInviteError: '',
      sendingInviteSuccess: false,
      managingPassword: false,
      password: '',
      manualPasswordEdit: false,
      passwordError: '',
      isSavingPassword: false,
      isSavingPasswordSuccess: false,
      resetPasswordSuccess: false,
    }
    
    this.handleChangeRecord = this.handleChangeRecord.bind(this)
    this.enableEditing = this.enableEditing.bind(this)
    this.handleChangeAddressRecord = this.handleChangeAddressRecord.bind(this)
    this.handleChange = this.handleChange.bind(this)
    this.toggleModal = this.toggleModal.bind(this)
  }

  componentDidMount() {
     const data = {
      educators: this.props.educators,
      schools: this.props.schools,
      students: this.props.students,
      districts: this.props.districts,
      classes: this.props.classes,
    }
    const recordData = getRecordType(this.props.recordId, data)
    this.setState({
      recordType: recordData.recordType,
      record: recordData.record
    })

  }

  componentWillReceiveProps(nextProps) {
    const districtAdded = keys(nextProps.districts).length !== keys(this.props.districts).length
    if ((this.props.recordId !== nextProps.recordId) || districtAdded) {
      const data = {
        educators: this.props.educators,
        schools: this.props.schools,
        students: this.props.students,
        districts: this.props.districts,
        classes: this.props.classes,
      }
      const recordData = getRecordType(nextProps.recordId, data)
      this.setState({
        recordType: recordData.recordType,
        record: recordData.record
      })
    }
  }

  toggleModal() {
    this.setState({
      error: '',
      editMode: false,
      isSaving: false,
      savingComplete: false,
      sendingInvite: false,
      sendingInviteError: '',
      sendingInviteSuccess: false,
      managingPassword: false,
      password: '',
      manualPasswordEdit: false,
      passwordError: '',
      isSavingPassword: false,
      isSavingPasswordSuccess: false,
      resetPasswordSuccess: false,
    })
    this.props.toggle()
  }

  handleChangeRecord(e) {
    this.setState({
      ...this.state,
      savingComplete: false,
      sendingInviteSuccess: false,
      record: {
        ...this.state.record,
        [e.target.name]: e.target.value,
      }
    })
  }

  handleChangeAddressRecord(e) {
    this.setState({
      ...this.state,
      savingComplete: false,
      sendingInviteSuccess: false,
      record: {
        ...this.state.record,
        address: {
          ...this.state.record.address,
          [e.target.name]: e.target.value,
        }
      }
    })
  }

  enableEditing() {
    this.setState({editMode: true,})
  }

  resendInvite() {
    const record = this.state.record
    const time = timestamper()
    const id = uuid()
    const invite = {
      id,
      createdDate: time,
      email: record.email,
      expirationDate: time + 259200000, // 3 days
      firstName: record.firstName,
      lastName: record.lastName,
      userId: record.id,
    }
    this.setState({sendingInvite: true,})
    db.collection('userInvites').doc(id).set(invite)
      .then(() => this.setState({sendingInvite: false, sendingInviteSuccess: true,}))
      .catch((err) => {
        this.setState({
          sendingInvite: false, 
          sendingInviteError: 'Error saving new invitation to database.'
      })
    })
  }

  saveChanges() {
    const isEducator = (
      this.state.recordType === 'District Admin' ||
      this.state.recordType === 'School Admin' ||
      this.state.recordType === 'Teacher'
    )
    const isStudent = this.state.recordType === 'Student'
    const isClass = this.state.recordType === 'Class'
    if (this.state.recordType === 'District' || 
        this.state.recordType === 'School' || 
        isEducator || isStudent ||
        isClass
      ) {
      let data = this.state.record
      if (data) {
        this.setState({isSaving: true, error: ''})
        let error = ''
        if (this.state.recordType === 'District' || this.state.recordType === 'School') {
          if (!data.name) {
            error = 'Name field is required.'
          } else if (!data.state) {
            error = 'State field is required.'
          } 
        }
        if (isEducator) {
          if (!data.firstName) {
            error = 'First name field is required.'
          } else if (!data.lastName) {
            error = 'Last name field is required.'
          } else if (!data.email) {
            error = 'Email is required.'
          }
        }
        if (isStudent) {
          if (!data.firstName) {
            error = 'First name field is required.'
          } else if (!data.lastName) {
            error = 'Last name field is required.'
          } else if (!data.email && !data.username) {
            error = 'Email or username is required.'
          } 
          if (data.email) {
            const checkAt = data.email.search('@') === -1
            const checkDot = data.email.search('.') === -1
            if (checkAt || checkDot) {
              error = 'Email invalid.'
            }
          }
        }
        if (isClass) {
          if (!data.name && !data.period) {
            error = 'Class name or period is required.'
          } 
        }
        if (error) {
          this.setState({isSaving: false, error, })
        } else {
          if (this.state.recordType === 'District' || this.state.recordType === 'School') {
            data.address.state = data.state
          } else if (isEducator || isStudent) {
            data.fullName = `${data.firstName} ${data.lastName}`
          } else if (isClass) {
            if (!data.name) {
              data.name = data.period
            }
          }

          data.lastModified = timestamper()
          let collectionName
          if (this.state.recordType === 'District') {
            collectionName = 'districts'
          } else if (this.state.recordType === 'School') {
            collectionName = 'schools'
          } else if (isEducator) {
            collectionName = 'educators'
          } else if (isStudent) {
            collectionName = 'students'
          } else if (isClass) {
            collectionName = 'classes'
          }
          db.collection(collectionName).doc(data.id).set(data, {merge: true})
            .then(() => this.setState({isSaving: false, savingComplete: true, editMode: false, }))
            .catch((err) => {
             this.setState({isSaving: false, savingComplete: false, error: 'Error saving changes to database.'})
            })
        }
      }
    }
  }

  cancel() {
    this.setState({editMode: false,})
    this.props.toggle()
  }

  togglePasswordManagement() {
    this.setState({managingPassword: !this.state.managingPassword})
  }

  toggleManualPasswordEdit() {
    this.setState({manualPasswordEdit: !this.state.manualPasswordEdit})
  }

  handleChange(e) {
    this.setState({[e.target.name]: e.target.value})
  }

  savePassword() {
    if (!this.state.password) {
      this.setState({passwordError: 'Password is required.'})
    } else {
      this.setState({isSavingPassword: true,})
      const isEducator = (
        this.state.recordType === 'District Admin' ||
        this.state.recordType === 'School Admin' ||
        this.state.recordType === 'Teacher'
      )
      if (isEducator || this.state.recordType === 'Student') {
        const data = {
          id: this.state.record.id,
          password: this.state.password,
        }
        let endpoint = ''
        if (isEducator) {
          endpoint = 'Educator'
        } else if (this.state.recordType === 'Student') {
          endpoint = 'Student'
        }
        const query = queryString.stringify(data)
        const url = `https://us-central1-bellwork-cg1.cloudfunctions.net/manualAdd${endpoint}?${query}`
        getRequest(url)
          .then(() => this.setState({
            passwordError: '', 
            isSavingPassword: false, 
            isSavingPasswordSuccess: true,
            password: '',
          }))
          .catch((err) => {
             this.setState({
              passwordError: 'Error saving password to database.',
              isSavingPassword: false,
              isSavingPasswordSuccess: false,
            })
          })
      }
    }
  }

  resetPassword() {
    this.setState({isSavingPassword: true})
    const id = uuid()
    const time = timestamper()
    const record = this.state.record
    db.collection('passwordResets').doc(id).set({
      id,
      userId: record.id,
      createdDate: time,
      expirationDate: time + 3600000, // 1 hour
      email: record.email,
      sent: false,
      firstName: record.firstName,
      lastName: record.lastName,
      complete: false,
    })
      .then(() => {
        this.setState({
          isSavingPassword: false,
          resetPasswordSuccess: true,
        })
      })
      .catch((err) => {
        this.setState({
          isSavingPassword: false,
          passwordError: 'Error creating password in database.'
        })
      })
  }

  

  render() {
    let userFormGroups = []
    const hasName = (
      this.state.recordType === 'District' ||
      this.state.recordType === 'School'
    )
    const isEducator = (
      this.state.recordType === 'District Admin' ||
      this.state.recordType === 'School Admin' ||
      this.state.recordType === 'Teacher'
    )
    const isStudent = this.state.recordType === 'Student'
    const isClass = this.state.recordType === 'Class'

    if (hasName || isClass) {
      userFormGroups.push(
        <UserFormGroup
          inputType='text'
          label='Name'
          name='name'
          placeholder='Name'
          handleChange={this.handleChangeRecord}
          value={this.state.record.name}
          className={this.state.error === 'Name field is required.' && !this.state.record.name ? 'is-invalid' : null}
          editMode={this.state.editMode}
          handleClick={this.enableEditing}
          key={'NameFormGroup'}
        />
      )
    }

    if (isClass) {
      userFormGroups.push(
        <UserFormGroup
          inputType='text'
          label='Period'
          name='period'
          placeholder='period'
          handleChange={this.handleChangeRecord}
          value={this.state.record.period}
          className={
            this.state.error === 'Class name or period is required.' && !this.state.record.name && !this.state.record.period 
            ? 'is-invalid' 
            : null
          }
          editMode={this.state.editMode}
          handleClick={this.enableEditing}
          key={'PeriodFormGroup'}
        />
      )
    }

    if (isEducator || isStudent) {
      userFormGroups.push(
        <UserFormGroup
          inputType='text'
          label='First Name'
          name='firstName'
          placeholder='Bob'
          handleChange={this.handleChangeRecord}
          value={this.state.record.firstName}
          className={this.state.error === 'First name is required.' && !this.state.record.firstName ? 'is-invalid' : null}
          editMode={this.state.editMode}
          handleClick={this.enableEditing}
          key={'FirstNameFormGroup'}
        />
      )
      userFormGroups.push(
          <UserFormGroup
            inputType='text'
            label='Last Name'
            name='lastName'
            placeholder='Jovi'
            handleChange={this.handleChangeRecord}
            value={this.state.record.lastName}
            className={this.state.error === 'Last name is required.' && !this.state.record.lastName ? 'is-invalid' : null}
            editMode={this.state.editMode}
            handleClick={this.enableEditing}
            key={'LastNameFormGroup'}
          />
      )
    }

    if (isEducator || isStudent) {
      userFormGroups.push(
        <UserFormGroup
          inputType='text'
          label='Email'
          name='email'
          placeholder='bobjovi@example.com'
          handleChange={this.handleChangeRecord}
          value={this.state.record.email}
          className={this.state.error === 'Email is required.' && !this.state.record.username ? 'is-invalid' : null}
          editMode={this.state.editMode}
          handleClick={this.enableEditing}
          key={'EmailFormGroup'}
        />
      )
    }

    if (isStudent) {
      userFormGroups.push(
        <UserFormGroup
          inputType='text'
          label='Username'
          name='username'
          placeholder='bobjovi'
          handleChange={this.handleChangeRecord}
          value={this.state.record.username}
          className={this.state.error === 'Email or username is required.' && !this.state.record.username ? 'is-invalid' : null}
          editMode={this.state.editMode}
          handleClick={this.enableEditing}
          key={'UsernameFormGroup'}
        />
      )
    }


    const hasAddress = (
      this.state.recordType === 'District' ||
      this.state.recordType === 'School'
    )

    if (hasAddress) {
      userFormGroups.push(
        <UserFormGroup
          inputType='text'
          label='Street Address Line 1'
          name='street1'
          placeholder='First line of street address'
          handleChange={this.handleChangeAddressRecord}
          value={this.state.record.address.street1 ? this.state.record.address.street1 : ''}
          editMode={this.state.editMode}
          handleClick={this.enableEditing}
          key={'Street1FormGroup'}
        />
      )
    }
    if (hasAddress) {
      userFormGroups.push(
        <UserFormGroup
          inputType='text'
          label='Street Address Line 2'
          name='street2'
          placeholder='Second line of street address'
          handleChange={this.handleChangeAddressRecord}
          value={this.state.record.address.street2 ? this.state.record.address.street2 : ''}
          editMode={this.state.editMode}
          handleClick={this.enableEditing}
          key={'Street2FormGroup'}
        />
      )
    }
    if (hasAddress) {
      userFormGroups.push(
        <UserFormGroup
          inputType='text'
          label='City'
          name='city'
          placeholder='City'
          handleChange={this.handleChangeAddressRecord}
          value={this.state.record.address.city ? this.state.record.address.city : ''}
          editMode={this.state.editMode}
          handleClick={this.enableEditing}
          key={'CityFormGroup'}
        />
      )
    }

    if (hasAddress) {
      userFormGroups.push(
        <UserFormGroup
          inputType='text'
          label='State'
          name='state'
          placeholder='State'
          handleChange={this.handleChangeRecord}
          value={this.state.record.state ? this.state.record.state : ''}
          editMode={this.state.editMode}
          handleClick={this.enableEditing}
          key={'StateFormGroup'}
          className={this.state.error === 'State field is required.' && !this.state.state ? 'is-invalid' : null}
        />
      )
    }
    if (hasAddress) {
      userFormGroups.push(
        <UserFormGroup
          inputType='text'
          label='Zip Code'
          name='zip'
          placeholder='99989'
          handleChange={this.handleChangeAddressRecord}
          value={this.state.record.address.zip ? this.state.record.address.zip : ''}
          editMode={this.state.editMode}
          handleClick={this.enableEditing}
          key={'ZipFormGroup'}
        />
      )
    }

    const hasSfid = (
      this.state.recordType === 'District' ||
      this.state.recordType === 'School' ||
      isEducator
    )
    if (hasSfid) {
      userFormGroups.push(
        <UserFormGroup
          inputType='text'
          label='SF Id'
          name='sfid'
          placeholder='001i000000Jdw9d'
          handleChange={this.handleChangeRecord}
          value={this.state.record.sfid ? this.state.record.sfid : ''}
          editMode={this.state.editMode}
          handleClick={this.enableEditing}
          key={'sfidFormGroup'}
        />
      )
    }

    let button
    if (this.state.editMode) {
      let buttonText
      if (this.state.savingComplete) {
        buttonText = 'Saved'
      } else {
        this.state.isSaving
        ? buttonText = <i className="fa fa-spinner fa-lg fa-spin"></i>
        : buttonText = 'Save Changes'
      }
      button = (
        <Button
          color='primary'
          disabled={this.state.isSaving || this.state.savingComplete}
          onClick={() => this.saveChanges()}
          className='ml-1'
        >
          {buttonText}
        </Button>
      )
    } else {
      button = (
        <Button
          color='secondary'
          onClick={() => this.enableEditing()}
          className='ml-1'
        >
          Edit
        </Button>
      )
    }

    let cancelButton = null
    if (this.state.editMode) {
      cancelButton = (
        <Button
          color='secondary'
          disabled={this.state.isSaving}
          onClick={() => this.cancel()}
          className='ml-1'
        >
          Cancel
        </Button>
      )
    }

    let usageDataAlert = null
    if (!this.state.editMode && !this.state.managingPassword) {
      if (this.state.recordType === 'District' || this.state.recordType === 'School' || isEducator || isStudent) {
        let lastLogin = ''
        let totalLogins
        if (isEducator || isStudent) {
          lastLogin = 'Never'
          totalLogins = 0
          if (this.state.record.activity) {
            if (this.state.record.activity.login) {
              const lastLoginMilli = getLastLogin(this.state.record.activity.login)
              const date = new Date(parseInt(lastLoginMilli, 10))
              lastLogin = date.toLocaleString()
              totalLogins = keys(this.state.record.activity.login).length
            }
          }
        }
        usageDataAlert = (
          <Alert color='secondary'>
            <ul>
              <li><b>Created:</b> {(new Date(this.state.record.created)).toLocaleDateString()}</li>
              <li><b>Last Modified:</b> {(new Date(this.state.record.lastModified)).toLocaleDateString()}</li>
              {this.state.record.validated ? <li>Registration completed.</li> : null}
              {lastLogin ? <li><b>Most Recent Login:</b> {lastLogin}</li> : null}
              {lastLogin ? <li><b>Total Logins:</b> {totalLogins}</li> : null}
            </ul>
          </Alert>
        )
      }
    }

    let deleteCollectionName
    if (this.state.recordType === 'District') {
      deleteCollectionName = 'districts'
    } else if (this.state.recordType === 'School') {
      deleteCollectionName = 'schools'
    } else if (isEducator) {
      deleteCollectionName = 'educators'
    } else if (isStudent) {
      deleteCollectionName = 'students'
    } else if (isClass) {
      deleteCollectionName = 'classes'
    }
    let deleteButton = (
      <Button
        color='danger'
        onClick={() => this.props.deleteRecord(deleteCollectionName, this.state.record.id)}
        disabled={this.state.isSaving || this.props.isDeleting}
      >
        {this.props.isDeleting ? <i className="fa fa-spinner fa-lg fa-spin"></i> : 'Delete'}
      </Button>
    )

    let headerText
    if (isEducator || isStudent) {
      headerText = `Manage ${this.state.recordType ? this.state.recordType : ''}: ${this.state.record ? this.state.record.fullName : ''}`
    } else {
      headerText = `Manage ${this.state.recordType}: ${this.state.record ? this.state.record.name : ''}`
    }

    let inviteAlert = null
    let resendButton = null
    if (this.state.record) {
      if (this.state.record.validated === false) {
        inviteAlert = <Alert color='warning'>Has not accepted invitation and set up account.</Alert>
        resendButton = (
          <Button 
            color='warning'
            disabled={this.state.sendingInvite || this.state.sendingInviteSuccess || this.state.isSaving || this.props.isDeleting}
            onClick={() => this.resendInvite()}
          >
            {this.state.sendingInvite ? <i className="fa fa-spinner fa-lg fa-spin"></i> : 'Resend Invite'}
          </Button>
        )
      }
    }

    let passwordButton = null
    if (this.state.record) {
      if (!this.state.editMode && this.state.record.validated && (isEducator || isStudent)) {
        passwordButton = (
          <Button
            color='warning'
            onClick={() => this.togglePasswordManagement()}
          >
            {this.state.managingPassword ? 'Close' : 'Manage Password'}
          </Button>
        )
      }
    }

    let passwordInput = null
    if (this.state.record) {
      if (this.state.manualPasswordEdit || !this.state.record.email) {
        passwordInput = (
          <div className='mt-1'>
            <UserFormGroup
              inputType='text'
              label='New Password'
              name='password'
              placeholder='sdfmi234uSD$'
              handleChange={this.handleChange}
              value={this.state.password}
              editMode={true}
              key={'Password'}
              className={this.state.passwordError === 'Password is required.' && !this.state.password ? 'is-invalid' : null}
              disabled={this.state.isSavingPassword}
            />
          </div>
        )
      }
    }


    let passwordAlert = null

    let passButtonText = ''
    if (this.state.record) {
      passButtonText = this.state.manualPasswordEdit || !this.state.record.email ? 'Save Password' : 'Reset Password'
      this.state.isSavingPassword ? passButtonText = <i className="fa fa-spinner fa-lg fa-spin"></i> : null
    }

    let passButton = null
    if (this.state.record) {
      passButton = (
        <Button
          color='info'
          disabled={this.state.isSavingPassword || this.state.resetPasswordSuccess}
          onClick={
            this.state.manualPasswordEdit || !this.state.record.email
            ? () => this.savePassword()
            : () => this.resetPassword()
          }
        >
          {passButtonText}
        </Button>
      )
    }

    let manualPasswordSwitch = (
      <div className='mt-2'>
        <Label className="switch switch-3d switch-info">
        <Input 
          type="checkbox" 
          className="switch-input" 
          checked={this.state.manualPasswordEdit} 
          onClick={() => this.toggleManualPasswordEdit()}/>
        <span className="switch-label"></span>
        <span className="switch-handle"></span>
        </Label> Manually Change Password
      </div>
    )
    if (this.state.record) {
      if (!this.state.record.email) {
        manualPasswordSwitch = null
      }
    }

    if (this.state.managingPassword && this.state.record && !this.state.editMode) {
      passwordAlert = (
        <Alert
          color='info'
        >  
          {passwordInput} 
          {passButton}
          {manualPasswordSwitch}
          {this.state.resetPasswordSuccess ? <p>Password reset email sent!</p> : null}
          {this.state.passwordError ? <p>{this.state.passwordError}</p> : null}
          {this.state.isSavingPasswordSuccess ? <p>New password saved!</p> : null}
        </Alert>
      )
    }



    return (
      <Modal isOpen={this.props.isOpen} toggle={this.toggleModal} className={'modal-primary'}>
        <ModalHeader toggle={this.toggleModal}>
          {headerText}
        </ModalHeader>
        <ModalBody>
          <Form>
            {userFormGroups}
          </Form>
          {inviteAlert}
          {usageDataAlert}
          {passwordAlert}
        </ModalBody>
        <ModalFooter>
          {this.state.error ? this.state.error : null}
          {this.state.sendingInviteSuccess ? <p>Successfully re-sent invitation.</p> : null}
          {this.props.isDeletingError ? <p>Error trying to delete this record.</p> : null}
          {button}
          {passwordButton}
          {resendButton}
          {cancelButton}
          {deleteButton}
        </ModalFooter>
      </Modal>
    )
  }
}

export default ManageRecordModal


// WEBPACK FOOTER //
// ./src/components/Users/ManageRecordModal.js